/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { useTheme } from '@coursera/cds-core';

const NavMenu: React.FC<{}> = ({ children }) => {
  const theme = useTheme();
  return (
    <div css={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      {React.Children.map(children, (child, index) => {
        return (
          <div
            key={`NavMenu-${index}`}
            css={{
              height: '100%',
              padding: '4px 30px 0 30px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderBottomWidth: '4px',
              borderBottomStyle: 'solid',
              borderBottomColor: 'transparent',
              ':hover': {
                borderBottomWidth: '4px',
                borderBottomStyle: 'solid',
                borderBottomColor: theme.palette.blue[600],
              },
              ':empty': {
                display: 'none',
              },
            }}
          >
            {child}
          </div>
        );
      })}
    </div>
  );
};

export default NavMenu;
